<div flexLayout="column" flexLayoutAlign="start stretch">
  <ng-container
    [ngTemplateOutlet]="template"
    [ngTemplateOutletContext]="{
      selectedTag: selectedTag$ | async,
      selectedTagType: selectedTagType$ | async,
      dataSource: (dataSource$ | async) || [],
      serviceCostOverrides: (serviceCostOverrides$ | async) || []
    }"
  >
  </ng-container>
</div>

<ng-template
  #template
  let-selectedTag="selectedTag"
  let-selectedTagType="selectedTagType"
  let-dataSource="dataSource"
  let-serviceCostOverrides="serviceCostOverrides"
>
  <div flexLayout="row" flexLayoutAlign="space-between center">
    <h3>
      Service Cost Pricing Plans
      <!-- {{ schema.title }} -->
    </h3>
    <button type="button" mat-raised-button color="primary" (click)="addPlan()">
      Add Pricing Plan
    </button>
  </div>

  <div flex flexLayout="column" flexLayoutAlign="start stretch">
    <div
      flexLayout="column"
      flexLayoutAlign="start stretch"
      *ngFor="let overridePlan of serviceCostOverrides"
      class="override"
    >
      <div flexLayout="row" flexLayoutAlign="space-between center" class="header">
        <div flexLayout="row" flexLayoutAlign="start center">
          <h3>{{ overridePlan.planName }}</h3>
          <button type="button" mat-icon-button color="primary" matTooltip="Edit Plan Name" (click)="updatePlanName(overridePlan)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <div flexLayout="row" flexLayoutAlign="end center" flexLayoutGap="1rem">
          <mat-checkbox
            [checked]="overridePlan.isDefault"
            labelPosition="before"
            matTooltip="Used when no specialty specified or it's not found"
            (change)="changeDefaultPlan(overridePlan)"
          >
            Default
          </mat-checkbox>
          <button
            *ngIf="feeBasedServicesEnabled$ | async"
            type="button"
            mat-icon-button
            color="primary"
            matTooltip="Add Service Fee"
            (click)="addServiceFee(overridePlan)"
          >
            <mat-icon>add service</mat-icon>
          </button>
          <button
            type="button"
            mat-icon-button
            color="warn"
            matTooltip="Delete Cost Plan and all related fees."
            (click)="deletePlan(overridePlan, selectedTag)"
          >
            <mat-icon>delete_forever</mat-icon>
          </button>
        </div>
      </div>
      <div flexLayout="column" flexLayoutAlign="start stretch" class="body">
        <table flex mat-table [dataSource]="overridePlan.serviceCosts">
          <ng-container matColumnDef="serviceFriendlyId">
            <th mat-header-cell *matHeaderCellDef>Service Type</th>
            <td mat-cell *matCellDef="let service">
              <ng-container
                *ngIf="
                  feeBasedServiceLookup$(service.friendlyId) | async as feeBasedService;
                  else loading
                "
              >
                {{ feeBasedService?.displayName }}
              </ng-container>
              <ng-template #loading>
                <mat-spinner [diameter]="14"></mat-spinner>
              </ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="serviceActive">
            <th mat-header-cell *matHeaderCellDef>Active</th>
            <td mat-cell *matCellDef="let service">
              <mat-icon *ngIf="service.active" color="accent" title="Active">toggle_on</mat-icon>
              <mat-icon *ngIf="!service.active" matTooltip="Inactive">toggle_off</mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="serviceFee">
            <th mat-header-cell *matHeaderCellDef>Fee</th>
            <td mat-cell *matCellDef="let service">{{ service.fee | currency }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let serviceFee; let i = index">
              <button
                type="button"
                mat-icon-button
                color="primary"
                title="Edit Service Cost Fee"
                (click)="editServiceFee(overridePlan, serviceFee)"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                type="button"
                mat-icon-button
                color="warn"
                title="Delete Service Cost Fee"
                (click)="deleteServiceFee(overridePlan, serviceFee, selectedTag)"
              >
                <mat-icon>delete_forever</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="['serviceFriendlyId', 'serviceActive', 'serviceFee', 'actions']"
          ></tr>
          <tr
            mat-row
            *matRowDef="
              let service;
              columns: ['serviceFriendlyId', 'serviceActive', 'serviceFee', 'actions']
            "
          ></tr>
          <!-- <tr mat-footer-row *matFooterRowDef="['specialties']"></tr> -->
        </table>
      </div>

      <div flexLayout="row" flexLayoutAlign="start center" flexLayoutGap="1rem" class="footer">
        <span>Specialties</span>
        <mat-chip-list
          flex
          flexLayout="row"
          flexLayoutAlign="start center"
          #chipList
          aria-label="Specialties selection"
        >
          <div flex flexLayout="row wrap" flexLayoutAlign="start center">
            <mat-chip
              flexLayout="row"
              flexLayoutAlign="start center"
              *ngFor="let specialty of overridePlan.specialties"
            >
              <span>{{ specialty | tagDisplay: undefined:false | async }}</span>
              <button
                type="button"
                matChipRemove
                (click)="deleteSpecialty(overridePlan.planName, specialty)"
              >
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
          </div>
        </mat-chip-list>
        <div flexLayout="row" flexLayoutAlign="end center">
          <!-- <button type="button" mat-raised-button color="primary" (click)="specialtiesHandler(table,tagState)">
            Add Specialty
          </button> -->
          <button
            type="button"
            mat-icon-button
            color="primary"
            matTooltip="Add Specialty"
            (click)="addSpecialty(overridePlan.planName)"
          >
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <table mat-table flex [dataSource]="dataSource">
    <ng-container matColumnDef="opinion-type">
      <td mat-cell *matCellDef="let overridePlan">
        <table flex mat-table [dataSource]="subTable$(overridePlan.serviceCosts)">
          <ng-container matColumnDef="default">
            <th mat-header-cell *matHeaderCellDef class="checkB" [attr.colspan]="4">
              <input
                type="checkbox"
                id="defaultChk"
                name="defaultChkName"
                matTooltip="Used when no specialty specified or it's not found"
                [checked]="overridePlan.isDefault"
                (change)="changeDefaultPlan(overridePlan)"
              />
              <label for="defaultChk">Default</label>
            </th>
          </ng-container>

          <ng-container matColumnDef="serviceFriendlyId">
            <th mat-header-cell *matHeaderCellDef>Service Type</th>
            <td mat-cell *matCellDef="let serviceFee">
              <ng-container
                *ngIf="
                  feeBasedServiceLookup$(serviceFee.friendlyId) | async as feeBasedService;
                  else loading
                "
              >
                {{ feeBasedService?.displayName }}
              </ng-container>
              <ng-template #loading>
                <mat-spinner [diameter]="14"></mat-spinner>
              </ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="serviceActive">
            <th mat-header-cell *matHeaderCellDef>Active</th>
            <td mat-cell *matCellDef="let serviceFee">
              <mat-icon *ngIf="serviceFee.active" color="accent" matTooltip="Active"
                >toggle_on</mat-icon
              >
              <mat-icon *ngIf="!serviceFee.active" matTooltip="Inactive">toggle_off</mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="serviceFee">
            <th mat-header-cell *matHeaderCellDef>Fee</th>
            <td mat-cell *matCellDef="let serviceFee">{{ serviceFee.fee | currency }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let serviceFee; let i = index">
              <!-- <button type="button" mat-icon-button color="primary" matTooltip="Edit Service Cost Fee"
                (click)="updateFeeBasedServiceHandler(override, row)">
                <mat-icon>edit</mat-icon>
              </button> -->
              <button
                type="button"
                mat-icon-button
                color="primary"
                matTooltip="Edit Service Cost Fee"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <!-- <button type="button" mat-icon-button color="warn" matTooltip="Delete Service Cost Fee"
                (click)="deleteFeeBasedServiceHandler(override, row)">
                <mat-icon>delete_forever</mat-icon>
              </button> -->
              <button
                type="button"
                mat-icon-button
                color="warn"
                matTooltip="Delete Service Cost Fee"
              >
                <mat-icon>delete_forever</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="header-opinion-display">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" class="notBorder">
              <ng-container>
                {{ overridePlan.planName }}
                <button type="button" mat-icon-button color="primary" matTooltip="Edit Plan Name">
                  <!-- <mat-icon (click)="updatePlanName(tagState,table.planName)">edit</mat-icon> -->
                  <mat-icon>edit</mat-icon>
                </button>
              </ng-container>
              <ng-template #loading>
                <mat-spinner [diameter]="14"></mat-spinner>
              </ng-template>
            </th>
          </ng-container>

          <ng-container matColumnDef="header-opinion-actions">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="1" class="notBorder">
              <!-- <button *ngIf="feeBasedServicesEnabled$ | async" type="button" mat-icon-button color="primary"
                matTooltip="Add Service Fee" (click)="addServiceCostOveride(table,tagState)">
                <mat-icon>add service</mat-icon>
              </button> -->
              <button
                *ngIf="feeBasedServicesEnabled$ | async"
                type="button"
                mat-icon-button
                color="primary"
                matTooltip="Add Service Fee"
              >
                <mat-icon>add service</mat-icon>
              </button>

              <!-- <button type="button" mat-icon-button color="warn" matTooltip="Delete Cost Plan and all related fees."
                (click)="deleteHandler(table.planName,tagState)">
                <mat-icon>delete_forever</mat-icon>
              </button> -->
              <button
                type="button"
                mat-icon-button
                color="warn"
                matTooltip="Delete Cost Plan and all related fees."
              >
                <mat-icon>delete_forever</mat-icon>
              </button>
            </th>
          </ng-container>

          <ng-container matColumnDef="specialties">
            <td mat-footer-cell *matFooterCellDef="" class="specialties" [attr.colspan]="4">
              <mat-toolbar>
                <span>Specialties</span>
                <span mat-spacer></span>
                <!-- <button type="button" mat-raised-button color="primary" (click)="specialtiesHandler(table,tagState)">
                  Add Specialty
                </button> -->
                <button type="button" mat-raised-button color="primary">Add Specialty</button>
              </mat-toolbar>

              <mat-form-field appearance="fill">
                <!-- <mat-chip-listbox #chipList aria-label="Specialties selection">
                  <div flexLayout="row wrap" *ngFor="let specialty of overridePlan.specialties">
                    <mat-chip>
                      showSpecialtyName
                      {{showSpecialtyName$(specialty) | async}}
                      <button type="button" matChipRemove (click)="deleteSpecialty(specialty,table,tagState)">
                        <mat-icon>cancel</mat-icon>
                      </button>
                      <button type="button" matChipRemove>
                        <mat-icon>cancel</mat-icon>
                      </button>
                    </mat-chip>
                  </div>
                </mat-chip-listbox> -->
              </mat-form-field>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="['header-opinion-display', 'header-opinion-actions']"
          ></tr>
          <tr mat-header-row *matHeaderRowDef="['default']"></tr>
          <tr
            mat-header-row
            *matHeaderRowDef="['serviceFriendlyId', 'serviceActive', 'serviceFee', 'actions']"
          ></tr>
          <tr
            mat-row
            *matRowDef="
              let service;
              columns: ['serviceFriendlyId', 'serviceActive', 'serviceFee', 'actions']
            "
          ></tr>
          <tr mat-footer-row *matFooterRowDef="['specialties']"></tr>
        </table>
      </td>
    </ng-container>
    <tr mat-row *matRowDef="let row; columns: ['opinion-type']"></tr>
  </table>
</ng-template>
